import {UI} from "../../../../../stem-core/ui/UIBase";

import {UserDashboardTab} from "./UserDashboardTab.jsx";
import {Messages} from "../../../../Messages";
import {UserDashboardSection} from "../components/UserDashboardSection.jsx";
import {UserDashboardPaymentsTable} from "../components/UserDashboardPaymentsTable.jsx";
import {Payment} from "../../../../../client/state/PaymentStore";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {PaymentMethod} from "../../../../../client/state/PaymentMethodStore";
import {startDonationFlow} from "../../../flows/FlowEntrypoint.js";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {Flow} from "../../../flows/Flow.js";


@autoredraw(PaymentMethod)
export class UserDashboardDonationTab extends UserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donations,
        };
    }

    renderDonation() {
        const {styleSheet} = this;
        const activeRecurringDonation = iFrameUserDataService.getActiveRecurringDonation();

        if (!activeRecurringDonation) {
            return [
                <UserDashboardSection titleMessage={Messages.donation}>
                    <MessageElement
                        className={styleSheet.textSection}
                        message={Messages.notRecurringDonorToMerchant(iFrameMerchantService.getMerchant().name)}
                    />
                    <BlinkButton
                        label={Messages.donate}
                        className={styleSheet.button}
                        onClick={() => startDonationFlow()}
                    />
                </UserDashboardSection>,
            ];
        }

        return [
            <UserDashboardSection
                titleMessage={Messages.recurringDonation}
                action={[Messages.edit, () => startDonationFlow(true)]}
            >
                <MessageElement
                    className={styleSheet.textSection}
                    message={Messages.recurringDonorContributing(activeRecurringDonation.formatPrice())}
                />
            </UserDashboardSection>,

            Flow.donationDetails.getOptionsForDonor().allowOneTime && <UserDashboardSection titleMessage={Messages.makeAnotherDonationTitle}>
                <MessageElement
                    className={styleSheet.textSection}
                    message={Messages.makeAnotherDonationText}
                />
                <BlinkButton
                    label={Messages.donate}
                    className={styleSheet.button}
                    onClick={() => startDonationFlow(false, true)}
                />
            </UserDashboardSection>,
        ];
    }

    renderPaymentHistory() {
        return <UserDashboardSection titleMessage={Messages.pastDonations}>
            <UserDashboardPaymentsTable resourceType={Payment.ResourceType.DONATION}/>
        </UserDashboardSection>;
    }

    render() {
        return [
            this.renderDonation(),
            this.renderPaymentHistory(),
        ];
    }
}
